let offers;
let product;
window.abModalVariant = 11;
function getCurrentlySelectedVariant(product) {
  selectedVariant = product.variants.find(
    (i) => i.id == mulberryShop.selectedVariantId
  );
  if (!selectedVariant) {
    selectedVariant = product.variants[0];
  }
  mulberryShop.selectedVariantId = selectedVariant.id;
  return selectedVariant;
}

async function mulberryPdpInit() {
  const HAS_MODAL = false; //mulberry.core.settings.has_modal;
  const HAS_INLINE = mulberry.core.settings.has_inline || true;
  if (window.location.pathname.indexOf("/products/") === -1) {
    // buyy_btn
    return;
  }
  
  if (!HAS_MODAL && !HAS_INLINE) {
    return;
  }
  const mulberryDiv = document.createElement('div');
  mulberryDiv.classList.add('mulberry-pdp-inline');
  mulberryDiv.style = "min-height: 100px;";
  document.querySelector('.mulberry-div-container').appendChild(mulberryDiv)

  let response = await mulberryShop.getProductData(
    mulberryShop.getProductUrl()
  );

  product = response.product;
  let selectedVariant = getCurrentlySelectedVariant(product);
  offers = await mulberry.core.getWarrantyOffer({
    id: selectedVariant.id,
    title: product.title,
    price: selectedVariant.price,
    detail: product,
  });
 
  // window.selectedOffer = {offer: offers[0], isSelected: true}
  
  if (HAS_INLINE) {
    
    window.pdpInline = await mulberry.inline.init({
      offers: offers,
      settings: mulberry.core.settings,
      selector: ".mulberry-pdp-inline",
      onWarrantyToggle: async (warranty) => {
        mulberry.inline.isSelected = warranty.isSelected;
        if (warranty.isSelected) {
          window.selectedOffer = warranty;
        } else {
          window.selectedOffer = null;
        }
      },
    });
  }
  if (HAS_MODAL) {
    window.pdpModal = await mulberry.modal.init({
      offers: offers,
      settings: mulberry.core.settings,
      onWarrantySelect: async (warranty) => {
        const result = await mulberryShop.getWarrantyVariant(warranty);
        await mulberryShop.addWarrantyToCart(
          result.shopify_variant_id,
          product,
          warranty
        );
        mulberry.modal.close();
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      },
      onWarrantyDecline: async () => {
        mulberry.modal.close();
      },
    });
  }

  document.addEventListener(
    "variant:change",
    async function (e) {
      //window.selectedOffer = null;
      //window.pdpInline.deselectOffer();
      if (HAS_INLINE) {
        //window.pdpInline.updateOffer();
      }
      if (HAS_MODAL) {
        //window.pdpModal.updateOffer();
      }
      // selectedVariant = e.detail.variant;
      // offers = await mulberry.core.getWarrantyOffer({
      //   id: selectedVariant.id,
      //   title: product.title,
      //   price: `${(selectedVariant.price/100).toFixed(2)}`,
      //   detail: product,
      // });

      // if (HAS_INLINE) {
      //   window.pdpInline.updateOffer(offers);
      // }
      // if (HAS_MODAL) {
      //   window.pdpModal.updateOffer(offers);
      // }
    }
  );
}

document
  ?.querySelector(".buy-buttons button")
  ?.addEventListener("click", async function (ev) {
    const btnClass = Array.from(ev?.target?.classList).find((el) => el === 'select_size_btn')

    if(btnClass !== undefined) {
      return;
    }
     
    const HAS_MODAL = false; //mulberry.core.settings.has_modal;
    const HAS_INLINE = mulberry.core.settings.has_inline || true;

    const handleClick = async () => {
      if (HAS_INLINE && window.selectedOffer) {
        setTimeout(async function () {
           await addWarranty();
        }, 500)
      } else if (HAS_MODAL && !window.selectedOffer) {
        window.pdpModal.open();
      }
    };

    await Promise.resolve().then(handleClick);
  });

async function addWarranty() {
  addToCartButtonClicked = true;
  if (!offers || offers.length == 0) {
    return;
  }
  try {
    let result;
    cart = await fetch("/cart.js");
    cartJson = await cart.json();
    if (window.selectedOffer) {
      result = await mulberryShop.getWarrantyVariant(
        window.selectedOffer.offer
      );
      const final = await mulberryShop.addWarrantyToCart(
        result.shopify_variant_id,
        {
          ...product,
          title: product.title,
          variantId: mulberryShop.selectedVariantId,
        },
        window.selectedOffer.offer
      );
      //window.pdpInline.deselectOffer();
      window.selectedOffer = null;
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }
  } catch (err) {
    console.log("mulberry error: ", err);
  }
  //mulberry.inline.deselectOffer();
}

document.addEventListener('mulberry-shopify:warranty-added', async (e) => {
  setTimeout(async () => {
    await removeAndSyncWarranties();
  }, 1200)
})

document.addEventListener("mulberry-shopify:loaded", async function (e) {
  window.mb_gtm_is_disabled = true
  setupFetchListeners();
  await removeAndSyncWarranties();
  if (document.location.href.includes("/products/")) {
    mulberryPdpInit();
  }

  let lastUrl = location.href;

  let theVariant;
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
    
  async function handleUrlChange() {
    var variant = getUrlParameter('variant');  
    if (variant && theVariant !== variant) {
      theVariant = variant

      //window.selectedOffer = null;
      //window.pdpInline.deselectOffer();
      
      // if (mulberry.core.settings.has_inline) {
      //   window.pdpInline.updateOffer([]);
      // }
      // if (mulberry.core.settings.has_modal) {
      //   window.pdpModal.updateOffer([]);
      // }

      mulberryShop.selectedVariantId = variant
      selectedVariant = getCurrentlySelectedVariant(product);
      offers = await mulberry.core.getWarrantyOffer({
        id: selectedVariant.id,
        title: product.title,
        price: selectedVariant.price,
        detail: product,
      });
      
      if (mulberry.core.settings.has_inline) {
        window.pdpInline.updateOffer(offers);
      }
      
      if (mulberry.core.settings.has_modal) {
        window.pdpModal.updateOffer(offers);
      }
      
    }
  }
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function() {
      if (lastUrl !== location.href) {
        lastUrl = location.href;
        handleUrlChange();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  handleUrlChange();    
  
  await mulberryShop.cart.init();
  mulberryShop.cart.render();
});

document.addEventListener("fetch:cart-change", async function () {
  await removeAndSyncWarranties();
});

document.addEventListener("fetch:cart-add", async function () {
  // await removeAndSyncWarranties();
});


async function removeAndSyncWarranties() {
  await fetch("/cart.js", {
    credentials: "same-origin",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  }).then(function (cart) {
    cart.json().then(function (firstCart) {
      newItems = [];
      cartItems = firstCart.items;
      for (i = 0; i < cartItems.length; i++) {
        item = cartItems[i];
        newItems.push(item);
      }
      firstCart.items = newItems;
      mulberryShop
        .removeDetachedWarranty(firstCart) // Remove Warranties First
        .then(async(newCart) => {
          mulberryShop.cart.syncQuantities(newCart).then(async(syncedCart)=>{
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
            // setTimeout(async () => {
            //   await mulberryShop.cart.init();
            //   await mulberryShop.cart.render();
            // }, 500);
          });
        });
    });
  });
}

// async function rebuildCart(){
//   const cartDrawerElem = document.querySelector('cart-drawer');
//   const cartNotificationElem = document.querySelector('cart-notification');
//   const cartItemsElem = document.querySelector('cart-items');
//   const pageToBuild = cartItemsElem || cartDrawerElem || cartNotificationElem;
//   const sectionsToRender = pageToBuild.getSectionsToRender();
//   const sectionNames = [];
  
//   for (let i = 0; i < sectionsToRender.length; i++) {
//     if(sectionsToRender[i].section){
//       sectionNames.push(sectionsToRender[i].section);
//     }else if(sectionsToRender[i].id){
//       sectionNames.push(sectionsToRender[i].id);
//     }
//   }
  
//   const queryParam = sectionNames.join(",");
//   const latestCart = await fetch(`/cart?sections=${queryParam}`, {
//     credentials: "same-origin",
//     method: "GET",
//     headers: {
//       "Content-Type": "application/json",
//       "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
//     },
//   })
//   const parsedState = await latestCart.json();

//   if(cartNotificationElem){
//     cartNotificationElem.getSectionsToRender()?.forEach((section => {
//       document.getElementById(section.id).innerHTML =
//       cartNotificationElem?.getSectionInnerHTML(parsedState[section.id], section.selector);
//     }));
//   } 

//   if(cartDrawerElem){
//     cartDrawerElem.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
//     cartDrawerElem.getSectionsToRender().forEach((section => {
//       const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
//       if(parsedState[section.id]){
//         sectionElement.innerHTML =
//         cartDrawerElem?.getSectionInnerHTML(parsedState[section.id], section.selector);
//       }
//     }));
//   }

//   if(cartItemsElem){
//     cartItemsElem.getSectionsToRender().forEach((section => {
//       const elementToReplace =
//         document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
//       elementToReplace.innerHTML =
//       cartItemsElem?.getSectionInnerHTML(parsedState[section.section], section.selector);
//       (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined' && typeof window.BOLD.common.eventEmitter.emit !== 'undefined' && (BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded')));
//     }));
//   }

// }

async function rebuildCart(){
  const cartDrawerElem = document.querySelector('cart-drawer');
  const cartNotificationElem = document.querySelector('cart-notification');
  const cartItemsElem = document.querySelector('cart-items');
  const pageToBuild = cartItemsElem || cartDrawerElem || cartNotificationElem;
  const sectionsToRender = pageToBuild.getSectionsToRender();
  const sectionNames = [];
  
  for (let i = 0; i < sectionsToRender.length; i++) {
    if(sectionsToRender[i].section){
      sectionNames.push(sectionsToRender[i].section);
    }else if(sectionsToRender[i].id){
      sectionNames.push(sectionsToRender[i].id);
    }
  }
  
  const queryParam = sectionNames.join(",");
  const latestCart = await fetch(`/cart?sections=${queryParam}`, {
    credentials: "same-origin",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  })
  const parsedState = await latestCart.json();

  if(parsedState['cart-drawer']) {
    const extractCartDrawerContents = (html) => {
      if(!html) {
        return null
      }
      const match = html.match(/(<cart-drawer[^>]*>.*?<\/cart-drawer>)/ims);
      return match && match[1] ? match[1].trim() : null;
    };

    const cartDrawerContents = extractCartDrawerContents(parsedState['cart-drawer']);
  
    const addClassToCartDrawer = (html, newClass) => {
      if(!html) {
        return null
      }
      return html.replace(/<cart-drawer([^>]*)class="([^"]*)"/i, `<cart-drawer$1class="$2 ${newClass}"`);
    };
  
    let updatedCartDrawerContents = cartDrawerContents

    if (document.querySelector('.custom_drawer').classList.contains('active')) {
      updatedCartDrawerContents = addClassToCartDrawer(cartDrawerContents, 'active');
    }
    
    document.querySelector(".main-cart-drawer-wrapper").innerHTML = updatedCartDrawerContents
  }

  if (window.location.href.includes('/cart')) {
    document.querySelector('.shopify-section.cart__items-wrapper').outerHTML = parsedState[document.querySelector('cart-items').getSectionsToRender()[0].section]
  }
  
  await mulberryShop.cart.init();
  mulberryShop.cart.render();

  if(document.querySelector(".cart-count-bubble span")) {
    let currentCart = await fetch('/cart.js')
    currentCart = await currentCart.json()
    document.querySelector(".cart-count-bubble span").innerHTML = currentCart.item_count
  }
  
  /* if(cartNotificationElem){
    cartNotificationElem.getSectionsToRender()?.forEach((section => {
      document.getElementById(section.id).innerHTML =
      cartNotificationElem?.getSectionInnerHTML(parsedState[section.id], section.selector);
    }));
  } 

  if(cartDrawerElem){
    cartDrawerElem.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    cartDrawerElem.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if(parsedState[section.id]){
        sectionElement.innerHTML =
        cartDrawerElem?.getSectionInnerHTML(parsedState[section.id], section.selector);
      }
    }));
  }

  if(cartItemsElem){
    cartItemsElem.getSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML =
      cartItemsElem?.getSectionInnerHTML(parsedState[section.section], section.selector);
      (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined' && typeof window.BOLD.common.eventEmitter.emit !== 'undefined' && (BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded')));
    }));
  } */

}

function setupFetchListeners() {
  const { fetch: origFetch } = window;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    let requestUrl = args[0];
    if (requestUrl.includes("cart/change") || requestUrl.includes("cart/add")) {
      response
        .clone()
        .json()
        .then((body) => {
          if (requestUrl.includes("cart/add")) {
            const fetchAddCustomEvent = new CustomEvent("fetch:cart-add");
            document.dispatchEvent(fetchAddCustomEvent);
          } else if (requestUrl.includes("cart/change")) {
            const fetchChangeCustomEvent = new CustomEvent("fetch:cart-change");
            document.dispatchEvent(fetchChangeCustomEvent);
          } else if (requestUrl.includes("cart/update")) {
            const fetchUpdateCustomEvent = new CustomEvent("fetch:cart-update");
            document.dispatchEvent(fetchUpdateCustomEvent);
          } else {
            if (requestUrl.includes("cart.php")) {
              const fetchCartCustomEvent = new CustomEvent("fetch:cart-page");
              document.dispatchEvent(fetchCartCustomEvent);
            }
          }
        })
        .catch((err) => console.error(err));
    }
    return response;
  };
}
